export const API_URL = process.env.REACT_APP_API_URL;

export const routeColors = [
  '#B1336E',
  '#67A43C',
  '#E6B43C',
  '#2563eb',
  '#dc2626',
  '#7c3aed',
  '#0891b2',
  '#ea580c',
  '#16a34a',
  '#be185d',
  '#475569',
  '#9333ea',
];

export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

export function formatTime(value) {
  if (!value) return '--:--';
  return new Date(value).toLocaleTimeString('es-PE', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function normalizeDriverSettings(drivers) {
  const result = {};
  drivers.forEach((driver) => {
    result[driver.user_id] = {
      selected: !!driver.is_route_enabled,
      user_id: driver.user_id,
      driver_id: driver.id,
      name: driver.name || `Driver ${driver.user_id}`,
      max_packages: driver.max_packages_default || 25,
      route_zone: driver.route_zone || '',
      preferred_districts: driver.preferred_districts || [],
      route_start_latitude: driver.route_start_latitude || '',
      route_start_longitude: driver.route_start_longitude || '',
    };
  });
  return result;
}

export function selectedDriversPayload(driverSettings, maxPackagesDefault) {
  return Object.values(driverSettings)
    .filter((driver) => driver.selected)
    .map((driver) => ({
      selected: true,
      user_id: driver.user_id,
      max_packages: Number(driver.max_packages || maxPackagesDefault),
      route_zone: driver.route_zone || null,
      preferred_districts: driver.preferred_districts || [],
      route_start_latitude: driver.route_start_latitude || null,
      route_start_longitude: driver.route_start_longitude || null,
    }));
}

export function driverPreferencePatch(driver, maxPackagesDefault) {
  return {
    route_zone: driver.route_zone,
    preferred_districts: driver.preferred_districts || [],
    max_packages_default: Number(driver.max_packages || maxPackagesDefault),
    route_start_latitude: driver.route_start_latitude || null,
    route_start_longitude: driver.route_start_longitude || null,
    is_route_enabled: driver.selected,
  };
}

export function getPlanMapPoints(plan, preview) {
  if (plan?.routes?.length) {
    return plan.routes.flatMap((route, routeIndex) =>
      (route.stops || [])
        .filter((stop) => stop.delivery?.latitude && stop.delivery?.longitude)
        .map((stop) => ({
          id: stop.delivery_point_id,
          lat: Number(stop.delivery.latitude),
          lng: Number(stop.delivery.longitude),
          district: stop.delivery.district,
          recipient_name: stop.delivery.recipient_name,
          slot: stop.delivery.slot || 0,
          priority: stop.is_priority || stop.delivery.priority,
          route_id: route.id,
          route_index: routeIndex,
          driver_name: route.driver_name,
          sequence: stop.sequence,
          eta: stop.planned_arrival_time,
          warning: stop.warning,
          color: routeColors[routeIndex % routeColors.length],
        }))
    );
  }

  return (preview?.deliveries || [])
    .filter((delivery) => delivery.latitude && delivery.longitude)
    .map((delivery) => ({
      id: delivery.id,
      lat: Number(delivery.latitude),
      lng: Number(delivery.longitude),
      district: delivery.district,
      recipient_name: delivery.recipient_name,
      slot: delivery.slot || 0,
      priority: delivery.priority,
      route_id: null,
      route_index: null,
      driver_name: null,
      sequence: null,
      eta: null,
      warning: null,
      color: delivery.priority ? '#E6B43C' : '#64748b',
    }));
}
